<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới Năm học / Hệ đào tạo : {{ configData.level.name | courseName}}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Năm học" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" placeholder="2021 - 2026"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="name_short" label="Viết tắt" class="form-item">
                  <el-input v-model="modelData.name_short" class="input-seach" placeholder="K1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Năm học'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        level_id: '',
        name: '',
        code: '',
        status: true
      },
      configData: {
        level: {
          id: 0,
          name: 'Tên khóa này'
        }
      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listLevel: []
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập năm học' }
        ]
      }
    }
  },
  mounted () {
    this.configDataAndBreadcrumb()
    // this.fetchListCategoryCourse()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình dữ liệu về khóa học, chương, cấu hình Breadcrumb
    configDataAndBreadcrumb () {
      this.modelData.level_id = this.$route.params.level_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('levels/' + this.$route.params.level_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.level = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'levels-index', text: 'Hệ đào tạo' },
        { name: 'levels-show', text: this.configData.level.name, level_id: this.$route.params.level_id },
        { name: 'keys-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'levels-show', params: {level_id: this.$route.params.level_id}})
      // this.$router.push({name: 'keys-index'})
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchListCategoryCourse () {
      axios.get('levels', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('keys', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm thành công',
              type: 'success'
            })
            // this.$router.push({name: 'keys-index'})
            let levelId = this.modelData.level_id
            this.modelData.name = ''
            this.modelData.code = ''
            this.$refs['createModel'].resetFields()
            this.modelData.level_id = levelId
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/keys/Create.vue